// extracted by mini-css-extract-plugin
module.exports = {"wrap":"src-components-layout-whiteBox-__index__wrap--3ND8E"};